import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M18,7.8A1.5,1.5,0,0,0,15.66,6L10.07,13a.21.21,0,0,1-.18.09.23.23,0,0,1-.19-.07L7.57,10.93a1.49,1.49,0,0,0-2.12,0,1.51,1.51,0,0,0,0,2.12l2.72,2.72a2.53,2.53,0,0,0,3.73-.22Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H16a1,1,0,0,0,.71-.29l7-7A1,1,0,0,0,24,16V2A2,2,0,0,0,22,0ZM2,2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5V15a.5.5,0,0,1-.5.5h-4a2,2,0,0,0-2,2v4a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }